import PracticeSelector from './src/main';

/* istanbul ignore next */
PracticeSelector.install = function(Vue) {
  Vue.component(PracticeSelector.name, PracticeSelector);
};

export default PracticeSelector;
